var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Fragment, PureComponent } from "react";
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
import { Label2 } from "@irati/ui/src/Labels";
import id from "@irati/utils/id";
import ErrorText from "@irati/ui/src/ErrorText";
import { ValidationButton, Hidden } from "@irati/ui/src/FormItem";
import { Recognition } from "@irati-web/fields/poll/votes";
import { recognitionSchema } from "@irati-web/fields/poll/votes/validation";
import CreatePollVoteMutation from "@irati/recognition/apollo/mutation/Vote/Create";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import tracking from "@irati-tracking/recognition/poll";
import formatRelativeForOpenPolls from "@irati/recognition/utils/formatRelativeForOpenPolls";
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList";
import UserSearch from "@irati/ui/src/UserSearch";
import Actions from "./Actions";
import { CompanyValuesWrapper, Top, Bottom, TeamList, BigDesc, Form as FormBase, Heading } from "../shared/layouts";
import { VIEW } from "./Popup";
var Form = styled(FormBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
var EndDate = styled(Label2)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), greys.medium);
var CreateVote = /** @class */ (function (_super) {
    __extends(CreateVote, _super);
    function CreateVote() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            voteText: "",
            voteUser: null
        };
        _this.handleChange = function (voteText) { return _this.setState({ voteText: voteText }); };
        _this.handleSelectUser = function (_, voteUser) {
            _this.setState({ voteUser: voteUser });
        };
        _this.handlePollVoteComplete = function () {
            tracking.createPollVote();
            _this.props.selectScreen(VIEW);
        };
        _this.handlePollVoteError = function (response) {
            tracking.errorsPollVote(response);
        };
        return _this;
    }
    CreateVote.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, poll = _c.poll, intl = _c.intl, onDeleteSuccess = _c.onDeleteSuccess;
        var _d = this.state, voteText = _d.voteText, voteUser = _d.voteUser;
        var teamIds = ((_b = (_a = poll.teams) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
            var uuid = _a.uuid;
            return uuid;
        })) || [];
        return (React.createElement(Fragment, null,
            React.createElement(Top, { className: "center" },
                React.createElement(Actions, { poll: poll, onDeleteSuccess: onDeleteSuccess }),
                React.createElement(TeamList, { teams: poll.teams.results }),
                React.createElement(Heading, { withBody: true, bold: true }, poll.title),
                React.createElement(BigDesc, null, poll.desc),
                React.createElement(CompanyValuesWrapper, null,
                    React.createElement(CompanyValues, { companyValues: poll.companyValues })),
                React.createElement(EndDate, null, formatRelativeForOpenPolls(poll.endsAt, intl))),
            React.createElement(Bottom, null,
                React.createElement(Form, null,
                    React.createElement(UserSearch, { teamIds: teamIds, onChange: this.handleSelectUser, placeholder: "recognition.fields.poll.votes.placeholder", label: "recognition.fields.poll.votes.label", hideLabel: true, autoFocus: true, removeSelf: true }),
                    voteUser && (React.createElement(CreatePollVoteMutation, { poll: poll, user: voteUser, message: voteText, onCompleted: this.handlePollVoteComplete, onError: this.handlePollVoteError }, function (onClick, apolloState) { return (React.createElement(Fragment, null,
                        React.createElement(Recognition, { onChange: _this.handleChange, value: voteText }),
                        React.createElement(Hidden, { id: id("hidden-recognition", _this.props), name: id("hidden-recognition", _this.props), value: voteText, validation: recognitionSchema(intl) }),
                        apolloState.error && React.createElement(ErrorText, null, apolloState.errorMsg),
                        React.createElement(ValidationButton, { id: id("submit", _this.props), onClick: onClick, apolloState: apolloState, full: true, primary: true },
                            React.createElement(FormattedMessage, { id: "recognition.popup.votes.createVote.button" })))); }))))));
    };
    CreateVote.defaultProps = {
        id: "create-vote"
    };
    return CreateVote;
}(PureComponent));
export default injectIntl(CreateVote);
var templateObject_1, templateObject_2;
